import { motion } from "framer-motion";
import { Instagram, Facebook, MessageCircle, ArrowUpRight } from "lucide-react";
import { INSTAGRAM, FACEBOOK, WHATSAPP_LINK } from "@/data/content";

const EASE = [0.16, 1, 0.3, 1];

export default function SocialStrip() {
  return (
    <section
      data-testid="social-strip"
      aria-label="Follow ABHI Institute on social media"
      className="border-b border-brand-line bg-brand-surface"
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: EASE }}
        className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-8 px-6 py-14"
      >
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-brand-terra">
            Campus Life, Daily
          </p>
          <p className="mt-3 font-serif text-3xl font-light leading-tight md:text-4xl">
            Follow the journey{" "}
            <a
              data-testid="strip-instagram-handle"
              href={INSTAGRAM}
              target="_blank"
              rel="noreferrer"
              className="italic text-brand-terra underline decoration-brand-terra/30 underline-offset-8 transition-colors hover:decoration-brand-terra"
            >
              @abhiinstitutedelhi
            </a>
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <a
            data-testid="strip-instagram-link"
            href={INSTAGRAM}
            target="_blank"
            rel="noreferrer"
            className="group inline-flex items-center gap-2 rounded-full bg-brand-green px-6 py-3 text-sm font-semibold text-white transition-colors duration-300 hover:bg-brand-ink"
          >
            <Instagram className="h-4 w-4" />
            Instagram
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <a
            data-testid="strip-facebook-link"
            href={FACEBOOK}
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
            className="rounded-full border border-brand-green/30 p-3 text-brand-green transition-colors duration-300 hover:border-brand-green hover:bg-brand-green hover:text-white"
          >
            <Facebook className="h-5 w-5" />
          </a>
          <a
            data-testid="strip-whatsapp-link"
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noreferrer"
            aria-label="WhatsApp"
            className="rounded-full border border-brand-green/30 p-3 text-brand-green transition-colors duration-300 hover:border-brand-green hover:bg-brand-green hover:text-white"
          >
            <MessageCircle className="h-5 w-5" />
          </a>
        </div>
      </motion.div>
    </section>
  );
}
